import React from "react"
import { Box } from "rebass"
import Paper from "material-ui/Paper"
import Toggle from "material-ui/Toggle"
import TextField from "material-ui/TextField"
import { DivContent, DivTitle } from "../../styled"
import { SketchColorPicker, UploadItemArray } from "../../../../../components"

import { BoxImageItem } from "./BoxImageItem"
import BoxPosition from "./BoxPosition"
import BoxText from "./BoxText"
//,

class ItemCarousel extends React.Component {
  render() {
    const {
      styles,
      data,
      onChangeText,
      onUpdateBg,
      onToggleChecked,
      onTitle,
      onSubTitle,
      indexParent,
      updateImage,
      list,
    } = this.props
    return (
      <Box w={[1]}>
        <Box w={[1]} pb={[1]}>
          <TextField
            fullWidth={true}
            hintText=""
            name={`name-${indexParent}`}
            floatingLabelText={"Name"}
            value={data.name}
            onChange={(e) => onChangeText(e, indexParent)}
          />
        </Box>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Background</DivTitle>
          <DivContent>
            <Toggle
              label="use Background Image"
              style={{ width: 220 }}
              toggled={data.bg.isBgImage}
              onToggle={(e) => onToggleChecked(e, "isBgImage", indexParent)}
            />
            {data.bg.isBgImage ? (
              <Box w={[1]}>
                <UploadItemArray
                  type={`CarouselAnimationView-url_bg-${indexParent}`}
                  imageUrl={list[indexParent].url_bg}
                  onUpdateUrl={(value) => updateImage(value, "url_bg")}
                  title="Background Desktop"
                />
                <UploadItemArray
                  type={`CarouselAnimationView-url_bg_mobile-${indexParent}`}
                  imageUrl={list[indexParent].url_bg_mobile}
                  onUpdateUrl={(value) => updateImage(value, "url_bg_mobile")}
                  title="Background Mobile"
                />
              </Box>
            ) : (
              <SketchColorPicker
                title={"Background Color"}
                onUpdateColor={(color) =>
                  onUpdateBg("backgroundColor", color, indexParent)
                }
                color={data.bg.backgroundColor}
              />
            )}
          </DivContent>
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Position</DivTitle>
          <BoxPosition {...this.props} />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Title</DivTitle>
          <BoxText
            onUpdateValue={onTitle}
            data={data.title}
            styles={styles}
            index={indexParent}
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Subtitle</DivTitle>
          <BoxText
            onUpdateValue={onSubTitle}
            data={data.subtitle}
            styles={styles}
            index={indexParent}
          />
        </Paper>
        <Paper style={styles.paperText} zDepth={1}>
          <DivTitle>Image</DivTitle>
          <BoxImageItem {...this.props} />
        </Paper>
      </Box>
    )
  }
}

export default ItemCarousel



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/ItemCarousel.js